<ng-container *ngTemplateOutlet="fullView"></ng-container>
<ng-container *ngTemplateOutlet="dockView"></ng-container>

<ng-template #dockView>
    <div class="dock">
        @if (isTabletOrLower()) {
            <ng-container *ngTemplateOutlet="pointsInfoTemplate"></ng-container>
        }
    </div>
</ng-template>

<ng-template #fullView>
    <div
        class="header dark-background header-text box-container"
        aria-label="Header"
        libHideHeaderWithHeight
        (isHeaderHidden)="headerHidden($event)"
    >
        <div class="header-first-row">
            <h1 class="logo shopping-title">
                <a id="shopping-link" #logoLink aria-label="Home" [routerLink]="['/', href.HOME]">
                    <img alt="" height="31" src="assets/images/logos/rymax-logo.svg" width="128" />
                </a>
            </h1>

            <div class="right-side-wrapper">
                @if (isDesktopOrBigger()) {
                    <ng-container *ngTemplateOutlet="pointsInfoTemplate"></ng-container>
                }

                <div class="icons">
                    @if (isDevMode) {
                        <button
                            class="theme-toggle"
                            [attr.aria-label]="themeService.isDark() ? 'Switch to light theme' : 'Switch to dark theme'"
                            (click)="themeService.toggle()"
                        >
                            <mat-icon>{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
                        </button>
                    }

                    <button class="header-button" aria-label="Account" type="button" (click)="goToAccount()">
                        <mat-icon svgIcon="ico_account"></mat-icon>
                    </button>

                    <!-- RCP-441: wishlist disabled
                    <a class="header-button" aria-label="Wish list" [routerLink]="[href.WISHLIST]">
                        <mat-icon svgIcon="ico_heart"></mat-icon>
                    </a>
                    -->

                    <button
                        class="header-button bucket-icon"
                        type="button"
                        [attr.aria-label]="'Cart, ' + filteredCartCount() + ' items in the Cart'"
                        (click)="onToggleCart()"
                    >
                        <mat-icon svgIcon="ico_cart"></mat-icon>
                        <p class="bucket-icon__count breadcrumb" [class.visible]="filteredCartCount()">
                            {{ filteredCartCount() }}
                        </p>
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #pointsInfoTemplate>
    @if (userService.balance()) {
        <div
            class="points-info"
            aria-live="polite"
            role="status"
            [ariaLabel]="ariaLabelBalanceStatus()"
            [attr.aria-hidden]="false"
        >
            <mat-icon svgIcon="ico_credit_card"></mat-icon>
            <p class="breadcrumb d-block m-0">{{ userService.points() | appDigitsGrouping }} {{ rewardName() }}</p>
        </div>
    }
</ng-template>
